import {
    FunctionField,
    SimpleShowLayout,
    TextField,
    useRecordContext,
} from 'react-admin';
import {ComboResponse} from "../../interfaces/Combo/ComboResponse";
import { Link } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { formatDateTime, formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import { formatSlotSize } from "../../utils/FormatSlotSize";
import { MultiDayChefitService } from '../../services/MultiDayChefitService';
import ComboMultiChefitList from './ComboMultiChefitList';
import CustomReferenceField from '../Common/CustomReferenceField';
import CustomerPreferenceSummary from '../Customers/CustomerPreferenceSummary';
import { CustomerService } from '../../services/CustomerService';

let multiChefitService = new MultiDayChefitService()
let customerService = new CustomerService();

function ComboMetaShow() {
    let record = useRecordContext();
    let[multiChefitData,setMultiChefitData] = useState<any>([]);
    let [customerPreference, setCustomerPreference] = useState<any>({});
    const getMultiChefits = useCallback(async () => {
        let multiChefits = await multiChefitService.getAllMultiDayChefit(
            10, 
            0, 
            { 'comboOrderId': record?.id }, 
            {}
        );
        setMultiChefitData(multiChefits?.data?.map((multiChefit : any) => multiChefit?.id));
        
    }, [record?.id]);
    
    useEffect(() => {
        getMultiChefits();
    }, [getMultiChefits]);


    const refreshData = useCallback(
           () => {
           customerService
               .getCustomerPrefernceByCustomerId(Number(record?.customerData?.id))
               .then((data) => {
               setCustomerPreference(data);
               console.log(data);
               })
               .catch((err: any) => {
               });
           },
           [record?.customerData?.id]
       );
       
         useEffect(() => {
           refreshData();
         }, [refreshData]);

    return (
        <>
        <CustomerPreferenceSummary
            customerPreference={customerPreference}
            customerId={record?.customerData?.id}
        />
        <SimpleShowLayout>
            <div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%"}}>
                <SimpleShowLayout>
                    <TextField source="id" />
                    <TextField source="amount" />
                    <FunctionField
                        emptyText="---"
                        label="Discount coupon Id"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            <Link href={`/#/CouponsV2/${record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponId}/show`}>
                                {record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponId}
                            </Link>
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Purchased Pack Name"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponCode
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Sku Id"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            <Link href={`/#/CouponSku/${record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponSkuId}/show`}>
                                {record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponSkuId}
                            </Link>
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="No. of People"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponSkuData?.noOfPeople
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Slot Size"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            formatSlotSize(record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponSkuData?.slotSize)
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Sku Description"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponSkuData?.description
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Coupon Status"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.isActive ? 'Active' : 'InActive'
                        }
                    />
                    <TextField source="paymentStatus" />
                    <TextField source="createdByType" />
                    <CustomReferenceField
                        label="Created By"
                        listName={record?.createdByType === "CUSTOMER" ? "Customers" : "AdminUsers"}
                        source={"createdBy"}
                    />
                    <FunctionField
                        label="Created At"
                        render={(record?: any) =>
                            <span style={{ whiteSpace: 'nowrap' }}>{record?.createdAt ? formatDateTimeWithSeconds(record?.createdAt) : 'Not Available'}</span>
                        }
                    />
                    <FunctionField
                        label="Updated At"
                        render={(record?: any) =>
                            <span style={{ whiteSpace: 'nowrap' }}>{record?.updatedAt ? formatDateTimeWithSeconds(record?.updatedAt) : 'Not Available'}</span>
                        }
                    />
                </SimpleShowLayout>
                <SimpleShowLayout>
                    <FunctionField
                        emptyText="---"
                        label="Customer Name"
                        source="customerData.fname"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            [record?.customerData?.fname, record?.customerData?.lname]?.filter((each) => each !== null).join(' ')
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Customer Mobile"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.customerData?.mobile
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Razorpay order Id"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.razorpayOrderId
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Amount Paid"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.razorpayOrder?.amount
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Net Refundable Amount"
                        sortable={false}
                        render={(record?: ComboResponse) => {
                            const paid = Number(record?.razorpayOrder?.amount || 0);
                            const refunded = Number(record?.razorpayOrder?.refundAmount || 0);
                            if (!paid) return '---';
                            return String(Math.floor(paid - refunded));
                        }}
                    />
                    <FunctionField
                        label="Wallet Cash Used"
                        render={(record: any) =>
                        `${record?.walletBalanceUsed ? record?.walletBalanceUsed  : 'Not Available'}`
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Cashback Amount"
                        sortable={false}
                        render={(record?: any) => {
                            if (record?.cashback?.credited === true) {
                                return record?.cashback?.amount != null ? `₹${record.cashback.amount}` : '---';
                            }
                            if (record?.cashback?.credited === false) {
                                return 'Not Credited';
                            }
                            return '---';
                        }}
                    />
                    <FunctionField
                        emptyText="---"
                        label="Cashback %"
                        sortable={false}
                        render={(record?: any) =>
                            record?.cashback?.percent != null
                                ? `${record.cashback.percent}%`
                                : '---'
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Cashback Credited"
                        sortable={false}
                        render={(record?: any) =>
                            record?.cashback?.credited != null
                                ? (record.cashback.credited ? 'Yes' : 'No')
                                : '---'
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Cashback Expires At"
                        sortable={false}
                        render={(record?: any) =>
                            record?.cashback?.expiresAt
                                ? <span style={{ whiteSpace: 'nowrap' }}>{formatDateTime(record.cashback.expiresAt)}</span>
                                : '---'
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Coupons Used"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.totalTimesUsed
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Coupons remaining"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            Math.floor(record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.maximumUsageLimit - record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.totalTimesUsed)
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Max Usage Limit"
                        sortable={false}
                        render={(record?: ComboResponse) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.maximumUsageLimit
                        }
                    />

                    <FunctionField
                        emptyText="---"
                        label="Coupon Expiry date"
                        sortable={false}
                        render={(record?: any) =>
                            record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.expiresAt
                                ? <span style={{ whiteSpace: 'nowrap' }}>{formatDateTime(record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.expiresAt)}</span>
                                : '---'
                        }
                    />
                    <FunctionField
                        emptyText="---"
                        label="Coupon Valid For"
                        sortable={false}
                        render={(record?: ComboResponse) => {
                            function getRemainingDays(targetDate: any) {
                                let target = moment(targetDate);
                                let now = moment();
                                let remainingDays = target.diff(now, 'days');
                                if (remainingDays < 0) {
                                    return "N/A";
                                } else {
                                    return remainingDays + " days remaining";
                                }
                            }
                            return record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.expiresAt ? getRemainingDays(record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponData?.expiresAt) : '---'
                        }}
                    />
                </SimpleShowLayout>
                <SimpleShowLayout>
                    <ComboMultiChefitList multiChefitData = {multiChefitData}/>
                </SimpleShowLayout>
            </div>
        </SimpleShowLayout>
        </>
    )
}

export default ComboMetaShow;
